var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"scroll-progress"}},[_c('span',{ref:"scrollBar"})]),_c('AppHeader'),_c('router-view'),_c('FloatingQR')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }